// @flow
import * as actionTypes from "@owsi/catena/er2_map_userlayers/js/constants/action_types"

export const onHideAttributeTable = (key) => ({
    type: actionTypes.ATTRIBUTE_TABLE_HIDE,
    key,
})
